<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-start>
      <v-flex xs12 text-left>
        <span style="color: #000; font-size: 20px; font-family: poppinsbold"
          >All Products</span
        >
      </v-flex>
      <v-flex xs12 md12 pt-5 v-if="products && totalCount > 0">
        <v-layout wrap px-md-12 pb-3>
          <v-flex sm6 md4 v-for="(item, i) in products" :key="i" pt-lg-6>
            <v-card flat>
              <v-layout
                wrap
                justify-center
                text-center
                px-10
                py-6
                v-if="item.photos"
              >
                <v-flex xs12 pb-2 v-if="item.photos.length > 0">
                  <v-img contain height="250" :src="mediaURL + item.photos[0]">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color=" #FDAC53"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex xs12 pb-2 v-else>
                  <v-img
                    max-height="500"
                    :src="require('./../../../assets/images/no-image.png')"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color=" #FDAC53"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex style="font-family: poppinsbold" xs12>
                  {{ item.name }}
                </v-flex>

                <v-flex xs12 pt-1 v-if="item.discount > 0">
                  <span style="font-weight: bold">
                    Rs. {{ item.offerPrice }}
                  </span>
                  <del
                    ><span style="font-weight: bold">
                      Rs. {{ item.price }}
                    </span></del
                  >
                </v-flex>
                <v-flex xs12 pt-1 v-else>
                  <span style="font-weight: bold">
                    Rs. {{ item.offerPrice }}
                  </span>
                </v-flex>
                <v-flex xs12 pt-1>
                  <v-btn
                    width="100%"
                    small
                    color="#FEBD08"
                    :to="'ProductInfo?product=' + item._id"
                    ><span>View</span></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      ServerError: false,
      timeout: 5000,
      msg: null,
      products: [],
      currentPage: 1,
      pages: 0,
      totalCount: 0,
    };
  },

  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          userid: this.$route.query.seller,
          count: 12,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.products = response.data.data;
            this.totalCount = response.data.totalLength;
            this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      // var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
  },
};
</script>
<style>
.head {
  font-family: poppinsregular;
  font-size: 14px;
}
.content {
  font-family: poppinsbold;
  font-size: 13px;
}
</style>